import { AI_CHATS } from '../../../constants';
import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';

export const chatsStrategy = {
  supports: (assistant) => {
    return Object.values(AI_CHATS).includes(assistant.type);
  },

  init: async (assistant, message) => {
    const response = await sendRequest(
      () => callApi.post(`/api/ai/playground/chat?aiChatType=${assistant.value}`, message),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    return {
      threadId: response.data.threadId,
      response: response.data.response,
    };
  },

  reply: async (assistant, reply, threadId) => {
    const response = await sendRequest(
      () => callApi.post(`/api/ai/playground/chat?aiChatType=${assistant.value}&threadId=${threadId}`, reply),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    return {
      threadId: response.data.threadId,
      response: response.data.response,
    };
  },

  reset: async (assistant, threadId) => {
    const response = await sendRequest(
      () => callApi.post(`/api/ai/playground/chat/reset?threadId=${threadId}&aiChatType=${assistant.value}`),
      {
        onError: (e) => {
          throw e;
        },
      },
    );

    return response.data;
  },
};
